import { render } from "./TPAAdd.vue?vue&type=template&id=54b9972d&scoped=true"
import script from "./TPAAdd.vue?vue&type=script&lang=js"
export * from "./TPAAdd.vue?vue&type=script&lang=js"

import "./TPAAdd.vue?vue&type=style&index=0&id=54b9972d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b9972d"]])

export default __exports__